import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";

import loginModalStyle from "assets/jss/westmorland-lodge-44/components/loginModalStyle.jsx";
import SectionLogin from "./Sections/SectionLogin.jsx";

class LoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    };
    // this.handleClick = this.handleClick.bind(this);
    // this.handleClose = this.handleClose.bind(this);
  }
  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };
  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };
  render() {
    const { className, classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div>
        <Button
          aria-owns={open ? "login-popover" : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
          className={className}
        >
          {this.props.children}
        </Button>
        <Popover
          id="login-popover"
          open={open}
          onClose={this.handleClose}
          className={classes.popover}
          classes={{ paper: classes.paper }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          anchorEl={anchorEl}
        >
          <SectionLogin classes={classes} />
        </Popover>
      </div>
    );
  }
}

export default withStyles(loginModalStyle)(LoginModal);



// WEBPACK FOOTER //
// ./src/components/LoginModal/LoginModal.jsx